import { PeriscopeV3PaginatedList } from '..';
import { useQueryResource } from '@hooks';
import { WorkflowActionRow } from './WorkflowActionRow';
import { WorkflowActionSearch } from '.';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import React, { useCallback } from 'react';
const defaultParams = Object.assign(Object.assign({}, keyPaginationDefaultQueryParams), { hideInactive: true });
export const SearchablePeriscopeV3WorkflowActionList = ({ parentIndex, uri }) => {
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams,
        fallbackParams: keyPaginationFallbackQueryParams,
        uri
    });
    const renderActions = useCallback((action) => React.createElement(WorkflowActionRow, { action: action, key: action.sonarObjectId, parentIndex: parentIndex }), [parentIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement(WorkflowActionSearch, { onChange: updateParams, queryParams: queryParams }),
        React.createElement(PeriscopeV3PaginatedList, { loading: loading, onChange: updateParams, queryParams: queryParams, renderListItem: renderActions, resource: resource })));
};
